module.exports = __webpack_public_path__ + "img/gaixie_grey.ebf537d6.svg";